/**
 * Sector descriptions as the forms record them in English ("Manufacturing – cement and building materials"), in Arabic. A description
 * is read part by part around its dash; one with a part not listed here is shown as filed.
 */
const SECTORS: Record<string, string> = {
  manufacturing: "الصناعة التحويلية",
  cement: "الأسمنت",
  "cement and building materials": "الأسمنت ومواد البناء",
  "building materials": "مواد البناء",
  wholesale: "تجارة الجملة",
  retail: "تجارة التجزئة",
  "wholesale and retail": "تجارة الجملة والتجزئة",
  pharmaceuticals: "الأدوية",
  grocery: "المواد الغذائية",
  "food and beverages": "الأغذية والمشروبات",
  dairy: "الألبان",
  electronics: "الإلكترونيات",
  apparel: "الملابس",
  "facilities management": "إدارة المرافق",
  "transport and logistics": "النقل والخدمات اللوجستية",
  logistics: "الخدمات اللوجستية",
  telecommunications: "الاتصالات",
  healthcare: "الرعاية الصحية",
  "financial services": "الخدمات المالية",
  banking: "الخدمات المصرفية",
  insurance: "التأمين",
  energy: "الطاقة",
  construction: "التشييد",
  "real estate": "العقارات",
  agriculture: "الزراعة",
  tourism: "السياحة",
  hospitality: "الضيافة",
  education: "التعليم",
  media: "الإعلام",
  automotive: "السيارات",
  aviation: "الطيران",
};

export function sectorText(value: string | null | undefined, locale: string): string {
  if (!value) return "";
  if (!locale.startsWith("ar")) return value;
  const whole = SECTORS[value.trim().toLowerCase()];
  if (whole) return whole;
  const parts = value.split(/\s+[–-]\s+/).map((p) => SECTORS[p.trim().toLowerCase()]);
  return parts.every(Boolean) ? parts.join(" – ") : value;
}
